import { rootUrl } from "./global"

export const getJwtToken = (email, password) => rootUrl.post('/auth/login?version=v1', { email, password })

export const stateList = () => rootUrl.get('/list/state?version=v1')

export const verticalList = () => rootUrl.get('/list/vertical?version=v1')

export const businessVerticalList = () => rootUrl.get('/list/businessvertical?version=v1');

export const jobdesignaction = () => rootUrl.get('/list/jobdesignaction?version=v1');

export const statusList = () => rootUrl.get('/list/status?version=v1')

export const activitytypList = () => rootUrl.get('/list/activitytyp?version=v1')

export const showContributors = () => rootUrl.get('/list/userbyrole?version=v1')

export const createProject = (projectData) => rootUrl.post(`/project?version=v1`, projectData)

export const showProjects = (fy) => rootUrl.get(`/project/list/${fy}?version=v1`)

export const deleteProjectDataByID = (id) => rootUrl.delete(`/project/${id}?version=v1`)

export const getProjectDataByID = (id) => rootUrl.get(`/project/${id}?version=v1`)

export const deleteProjectActivity = (projectId, activityId) =>
    rootUrl.delete(`/project/activities/${projectId}/${activityId}?version=v1`);


export const updateProject = (projectData) => rootUrl.put(`/project?version=v1`, projectData)

export const firmReport = (id, dt) =>
    rootUrl.get(`/report/firm/${id}?version=v1`, {
        responseType: 'arraybuffer',
    });

export const weeklyReport = (fy, dt) =>
    rootUrl.get(`/report/weekly/${fy}?dt=${dt}&version=v1`, {
        responseType: 'arraybuffer',
    });

export const zoneWiseReport = (fy, dt) =>
    rootUrl.get(`/report/zonewise/${fy}?dt=${dt}&version=v1`, {
        responseType: 'arraybuffer',
    });

export const quarterlyReport = (fy, dt) =>
    rootUrl.get(`/report/quarterly_ongoing/${fy}?dt=${dt}&version=v1`, {
        responseType: 'arraybuffer',
    });

export const quarterlyNewBusinessReport = (fy, dt) =>
    rootUrl.get(`/report/quarterly_new/${fy}?dt=${dt}&version=v1`, {
        responseType: 'arraybuffer',
    });

export const timesheetReport = (startDate, endDate) => 
    rootUrl.get(`/report/timesheet?startDate=${startDate}&endDate=${endDate}&version=v1`, {
        responseType: 'arraybuffer',
    });

export const zonewiseTargetAchievementReport = (fy, dt) =>
    rootUrl.get(`/report/zonewise_target_achievement/${fy}?dt=${dt}&version=v1`, {
        responseType: 'arraybuffer',
    });

export const zonewiseActivityTrackerReport = (fy, dt) =>
    rootUrl.get(`/report/zonewise_activity_tracker/${fy}?dt=${dt}&version=v1`, {
        responseType: 'arraybuffer',
    });
    
export const zonewiseNewBusinessReport = (fy, dt) =>
    rootUrl.get(`/report/zonewise_new_business/${fy}?dt=${dt}&version=v1`, {
        responseType: 'arraybuffer',
    });
        
// export const viewDashboardEvents = (startDate, endDate) => rootUrl.get(`/dashboard/events?version=v1&startDate=${startDate}&endDate=${endDate}`)

export const viewDashboardEvents = (startDate, endDate, email) => {
  let url = `/dashboard/events?version=v2&startDate=${encodeURIComponent(startDate)}&endDate=${encodeURIComponent(endDate)}`;
  if (email) url += `&email=${encodeURIComponent(email)}`;
  return rootUrl.get(url);
};

export const viewDashboard = () => rootUrl.get('/dashboard/summary?version=v1')


export const uploadFile = (filedata) => rootUrl.post(`/cloud/upload?version=v1`, filedata)

export const showImage = (fileName) => {
    return rootUrl.get(`/cloud/download?version=v1&keyName=${fileName}`, {
        responseType: 'arraybuffer',
    });

};


export const getCVDataByID = (id) => rootUrl.get(`/cvs/${id}?version=v1`);

export const createCV = (cvs) => rootUrl.post(`/cvs?version=v1`, cvs);

//export const showFile = (id, page = 0, size = 20) => rootUrl.get(`/cvs?version=v1&page=${page}&size=${size}`);

//export const getCVData = (id, page = 0, size = 20) => rootUrl.get(`/cvs?version=v1&page=${page}&size=${size}`);


export const getCVData = (
  page = 0,
  size = 10,
  globalFilter = undefined,
  vertical = undefined,
  name = undefined,
  jobdesignation = undefined
) => {
  const params = new URLSearchParams({
    version: 'v1',
    page: page.toString(),
    size: size.toString()
  });

  // Add optional filters if they are provided (not undefined)
  if (globalFilter !== undefined) params.append('globalFilter', globalFilter);
  if (vertical !== undefined) params.append('vertical', vertical);
  if (name !== undefined) params.append('name', name);
  if (jobdesignation !== undefined) params.append('jobdesignation', jobdesignation);

  return rootUrl.get(`/cvs?${params.toString()}`);
};


//export const getCVData = (fy) => rootUrl.get(`/cvs?version=v1`);

export const deleteCVDataByID = (id) => rootUrl.delete(`/cvs/${id}?version=v1`);

// export const getPublicCvs = (id, page = 0, size = 20) =>
//   rootUrl.get(`/cvs/public/${id}?version=v1&page=${page}&size=${size}`);

export const getPublicCvs = (
  key, // Changed from id to key to match @PathVariable name
  page = 0,
  size = 10,
  globalFilter = undefined,
  vertical = undefined,
  name = undefined,
  jobdesignation = undefined
) => {
  const params = new URLSearchParams({
    version: 'v1',
    page: page.toString(),
    size: size.toString()
  });

  // Add optional filters if they are provided (not undefined)
  if (globalFilter !== undefined) params.append('globalFilter', globalFilter);
  if (vertical !== undefined) params.append('vertical', vertical);
  if (name !== undefined) params.append('name', name);
  if (jobdesignation !== undefined) params.append('jobdesignation', jobdesignation);

  return rootUrl.get(`/cvs/public/${key}?${params.toString()}`);
};

export const downloadpublicFile = (fileName) => {
    return rootUrl.get(`/cloud/download_03082025augsun171500-public?version=v1&keyName=${fileName}`, {
        responseType: 'arraybuffer',
    });

};